import { render, staticRenderFns } from "./DropdownQuestion.vue?vue&type=template&id=6a3b5c61&scoped=true&"
import script from "./DropdownQuestion.vue?vue&type=script&lang=js&"
export * from "./DropdownQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b5c61",
  null
  
)

export default component.exports